import React, { useState } from 'react';
import dayjs from 'dayjs';
import {
  ConditionalFilter,
  IResourceComponentsProps,
  useNavigation,
} from '@pankod/refine-core';
import {
  DataGrid,
  useDataGrid,
  GridColumns,
  List,
  TextField,
  Button,
  Stack,
} from '@pankod/refine-mui';
import { IGetUsers } from 'interfaces';

export const UserList: React.FC<IResourceComponentsProps> = () => {
  const { show, push } = useNavigation();
  const { dataGridProps, setFilters } = useDataGrid<IGetUsers>({
    initialPageSize: 1,
  });
  const [keyword, setKeyword] = useState('');
  const handleSearch = () => {
    if (keyword.trim() !== '') {
      const getField = (field: string): ConditionalFilter => ({
        operator: 'and',
        value: [
          {
            field,
            operator: 'gte',
            value: keyword,
          },
          {
            field,
            operator: 'lte',
            value: keyword + '\uf8ff',
          },
        ],
      });
      setFilters([
        {
          operator: 'or',
          value: [
            getField('email'),
            getField('ref_code'),
            getField('name'),
          ],
        },
      ]);
    } else {
      setFilters([]);
    }
  };

  const columns = React.useMemo<GridColumns<IGetUsers>>(
    () => [
      {
        field: 'id',
        headerName: 'id',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'email',
        headerName: 'Email',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'ref_code',
        headerName: 'Ref Code',
        flex: 1,
        minWidth: 60,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'points',
        headerName: 'Points',
        flex: 1,
        minWidth: 60,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'created_at',
        headerName: 'Created at',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
        renderCell: function render({ row }) {
          return (
            <>
              {dayjs(row.created_at.toDate()).format(
                'YYYY-MM-DD HH:mm:ss'
              )}
            </>
          );
        },
      },
      {
        field: 'updated_at',
        headerName: 'Updated at',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
        renderCell: function render({ row }) {
          return (
            <>
              {dayjs(row.updated_at.toDate()).format(
                'YYYY-MM-DD HH:mm:ss'
              )}
            </>
          );
        },
      },
    ],
    []
  );

  return (
    <List
      title="Users"
      cardProps={{ sx: { paddingX: { xs: 0, md: 0 } } }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Stack gap={2} direction="row" marginBottom="16px">
          <TextField
            variant="outlined"
            placeholder="Search by email, ref code, or name"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            sx={{ flex: 1 }}
          />
          <Button variant="contained" color="primary" type="submit">
            Search
          </Button>
        </Stack>
      </form>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        disableColumnFilter={true}
        disableColumnSelector={true}
        rowsPerPageOptions={[5, 10, 15, 20]}
        density="comfortable"
        sx={{
          '& .MuiDataGrid-cell:hover': {
            cursor: 'er',
          },
        }}
        onRowClick={(row) => {
          show('users', row.id);
        }}
      />
    </List>
  );
};
